import React, { Component } from "react"
import { Button, Glyphicon, OverlayTrigger, Popover } from "react-bootstrap"


class DataAccessRequestListItem extends Component {
  state = {
    errorMessage: "",
  }

  render() {
    const { request, activeTab, handleRequestActions } = this.props

    return (
      <React.Fragment>
        <tr className="data-access-request-table-item">
          <td>
            { request.data_source }
          </td>
          <td>
            { request.user }
          </td>
          <td>
            { request.client }
          </td>
          <td>
            { request.created_date }
          </td>
          { activeTab === "approved" ?
            <React.Fragment>
              <td>{request.approved_date}</td>
              <td>{request.expiration_date}</td>
              <td>{request.time_until_expiration}</td>
            </React.Fragment>
            :
            <td className="request-actions-col">
              { activeTab === "pending" &&
                <OverlayTrigger
                  placement="bottom"
                  trigger="click"
                  rootClose
                  overlay={
                    <Popover id='manager-info-popover' title="Approve Request">
                      <p>
                        Are you sure you want to approve this request.
                      </p>

                      <center>
                        <Button
                          onClick={ () => handleRequestActions("patch", request.url) }
                          className="request-action-btn"
                          bsStyle="primary"
                        >
                          Approve
                        </Button>
                      </center>
                    </Popover>
                  }
                >
                  <Button className="request-action-btn" bsStyle="primary">
                    <Glyphicon glyph="ok"/>
                  </Button>
                </OverlayTrigger>
              }
              <OverlayTrigger
                placement="bottom"
                trigger="click"
                rootClose
                overlay={
                  <Popover id='manager-info-popover' title="Delete Request">
                    <p>
                      Are you sure you want to delete this request.
                    </p>

                    <center>
                      <Button
                        onClick={ () => handleRequestActions("delete", request.url) }
                        className="request-action-btn"
                        bsStyle="danger"
                      >
                        Delete
                      </Button>
                    </center>
                  </Popover>
                }
              >
                <Button className="request-action-btn" bsStyle="danger">
                  <Glyphicon glyph="remove"/>
                </Button>
              </OverlayTrigger>
            </td>
          }
        </tr>
      </React.Fragment>
    )
  }
}

export default DataAccessRequestListItem


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/DataAccessRequestListItem.js